export interface ProblemDetails {
  type?: string;
  title?: string;
  status?: number;
  detail?: string;
  instance?: string;
  errors?: Record<string, string[]>;
  [key: string]: unknown;
}

interface StatusMessageEntry {
  titleKey: string;
  messageKey: string;
}

export class ResponseResult<T = any> {
  isSuccess: boolean;
  data: T | null;
  title?: string;
  detail?: string;
  statusCode?: number;

  constructor(params: {
    isSuccess: boolean;
    statusCode?: number;
    title?: string;
    detail?: string;
    data: T | null;
  }) {
    this.isSuccess = params.isSuccess;
    this.statusCode = params.statusCode;
    this.title = params.title;
    this.detail = params.detail;
    this.data = params.data;
  }
  static STATUS_CODE_MESSAGES: Record<number, StatusMessageEntry> = {
    400: {
      titleKey: "message.validation.title",
      messageKey: "message.validation.message",
    },
    401: {
      titleKey: "message.unauthenticated.title",
      messageKey: "message.unauthenticated.message",
    },
    403: {
      titleKey: "message.forbidden.title",
      messageKey: "message.forbidden.message",
    },
    404: {
      titleKey: "message.notFound.title",
      messageKey: "message.notFound.message",
    },
    409: {
      titleKey: "message.conflict.title",
      messageKey: "message.conflict.message",
    },
    422: {
      titleKey: "message.businessRuleRefused.title",
      messageKey: "message.businessRuleRefused.message",
    },
    500: {
      titleKey: "message.unexpected.title",
      messageKey: "message.unexpected.message",
    },
    502: {
      titleKey: "message.upstreamWrongResponse.title",
      messageKey: "message.upstreamWrongResponse.message",
    },
    503: {
      titleKey: "message.upstreamTemporaryUnavailable.title",
      messageKey: "message.upstreamTemporaryUnavailable.message",
    },
    504: {
      titleKey: "message.upstreamUnavailable.title",
      messageKey: "message.upstreamUnavailable.message",
    },
  };

  static fromProblemDetails<T = any>(
    problem: ProblemDetails,
    fallbackStatus = 500,
  ): ResponseResult<T> {
    return new ResponseResult<T>({
      isSuccess: false,
      statusCode: problem.status ?? fallbackStatus,
      title: problem.title,
      detail: problem.detail,
      data: null,
    });
  }

  /** Fallback: network failure, timeout, no response at all */
  static defaultError<T = any>(error: any): ResponseResult<T> {
    console.error(error);
    const message =
      error?.message ?? error ?? "Unknown Error - An undefined error occured";
    return new ResponseResult<T>({
      isSuccess: false,
      statusCode: 500,
      title: "Unknown Error",
      detail: message,
      data: null,
    });
  }
}
